export const StatusBGColor = {
    PENDING: "#FFBA53", 
    REVIEW_REQUESTED: "#78C6FF", 
    REJECTED: "#FF6F6F", 
    APPROVED: "#5EEEA9"
}